import { render } from "./ChangeCompany.vue?vue&type=template&id=343d49a2&ts=true"
import script from "./ChangeCompany.vue?vue&type=script&lang=ts"
export * from "./ChangeCompany.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__